import cssVariables from 'tfs.css-variables'

export default {
  wrapper: {
    position: 'absolute',
    left: 0,
    zIndex: 100,
    backgroundColor: cssVariables.colorWhite,
    borderRadius: '0.5rem',
    width: 'calc(100% + 2rem)',
    marginLeft: '-1rem',
    filter: 'drop-shadow(0 0.2rem 3px rgba(0,0,0,0.15))',
  },
  arrow: {
    '&::before': {
      content: '""',
      width: 0,
      height: 0,
      borderLeft: '0.8rem solid transparent',
      borderRight: '0.8rem solid transparent',
      position: 'absolute',
      left: '1.3rem',
    },
  },
  arrowBelow: {
    marginTop: '2.5em',
    '&::before': {
      borderBottom: `0.9rem solid ${cssVariables.colorWhite}`,
      bottom: '100%',
    },
  },
  arrowAbove: {
    marginTop: '-2.5em',
    '&::before': {
      borderTop: `0.9rem solid ${cssVariables.colorWhite}`,
      top: '100%',
    },
  },
  suggestions: {
    margin: '0.5rem 0',
    padding: 0,
    listStyle: 'none',
    maxHeight: '13rem',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  suggestion: {
    padding: '0.5rem 0.5rem 0.5rem 1.3rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: cssVariables.colorGrayE,
    },
  },
  focused: {
    backgroundColor: cssVariables.colorGrayE,
  },
}
